export const FONT_NORMAL = `'HT-Lato', sans-serif`
export const FONT_MONO = `'HT-PT-Sans-Mono', monospace`



// WEBPACK FOOTER //
// ./src/styles/type.js